export default function applyYears (campus = '') {
	let years = {
		default: [
			{
				value: '2026',
				text: '2026'
			},
			{
				value: '2027',
				text: '2027'
			}
		]
	};
	if (years.hasOwnProperty(campus.toLowerCase())) {
		return years[campus.toLowerCase()];
	}
	return years.default;
}

export function applySemesters (campus = '') {
	let semesters = {
		default: [
			{
				value: '1',
				text: 'Fall'
			},
			{
				value: '2',
				text: 'Spring'
			},
			{
				value: '3',
				text: 'Summer'
			}
		],
		uma: [
			{
				value: '1',
				text: 'Fall'
			},
			{
				value: '2',
				text: 'Spring'
			},
			{
				value: '3',
				text: 'Summer Full'
			},
			{
				value: '3a',
				text: 'Summer Session First'
			},
			{
				value: '3b',
				text: 'Summer Session Second'
			}
		],
		um: [
			{
				value: '1',
				text: 'Fall'
			},
			{
				value: '2',
				text: 'Spring'
			}
		],
		umf: [
			{
				value: '1',
				text: 'Fall'
			},
			{
				value: '2',
				text: 'Spring'
			},
			{
				value: "3",
				text: "Summer"
			}
		],
		umpi: [
			{
				value: '1',
				text: 'Fall'
			},
			{
				value: '2',
				text: 'Spring'
			}
		]
	};
	if (semesters.hasOwnProperty(campus.toLowerCase())) {
		return semesters[campus.toLowerCase()];
	}
	return semesters.default;
}
